import React from "react";
import PropTypes from "prop-types";

// css
import css from "./ShadowProfile";

export default class ShadowProfile extends React.PureComponent {
	static propTypes = {
		permissionLevel: PropTypes.string.isRequired,
		directReportCount: PropTypes.number.isRequired,
		subjectOfReviewCount: PropTypes.number.isRequired,
		authorOfReviewCount: PropTypes.number.isRequired,
		signerOfReviewCount: PropTypes.number.isRequired,
		activeAssignedGoalCount: PropTypes.number.isRequired,
		totalAssignedGoalCount: PropTypes.number.isRequired,
		feedbackSentCount: PropTypes.number.isRequired,
		feedbackReceivedCount: PropTypes.number.isRequired,
		completedTodoCount: PropTypes.number.isRequired,
	};

	render = () => {
		const {
			permissionLevel,
			directReportCount,
			subjectOfReviewCount,
			authorOfReviewCount,
			signerOfReviewCount,
			activeAssignedGoalCount,
			totalAssignedGoalCount,
			feedbackSentCount,
			feedbackReceivedCount,
			completedTodoCount,
		} = this.props;

		return (
			<div className={css.main}>
				<div className={css.fieldWrapper}>
					<div className={css.fieldLabel}>Permission Level</div>
					<div className={css.fieldValue}>{permissionLevel}</div>
				</div>

				<div className={css.fieldWrapper}>
					<div className={css.fieldLabel}>Direct Reports</div>
					<div className={css.fieldValue}>{directReportCount}</div>
				</div>

				<div className={css.fieldWrapper}>
					<div className={css.fieldLabel}>Reviews</div>
					<div className={css.fieldValue}>{subjectOfReviewCount}</div>
				</div>

				<div className={css.fieldWrapper}>
					<div className={css.fieldLabel}>Reviews Authored</div>
					<div className={css.fieldValue}>{authorOfReviewCount}</div>
				</div>

				<div className={css.fieldWrapper}>
					<div className={css.fieldLabel}>Reviews Signed</div>
					<div className={css.fieldValue}>{signerOfReviewCount}</div>
				</div>

				<div className={css.fieldWrapper}>
					<div className={css.fieldLabel}>Active Goals</div>
					<div className={css.fieldValue}>{activeAssignedGoalCount}</div>
				</div>

				<div className={css.fieldWrapper}>
					<div className={css.fieldLabel}>Total Goals</div>
					<div className={css.fieldValue}>{totalAssignedGoalCount}</div>
				</div>

				<div className={css.fieldWrapper}>
					<div className={css.fieldLabel}>Feedback Sent</div>
					<div className={css.fieldValue}>{feedbackSentCount}</div>
				</div>

				<div className={css.fieldWrapper}>
					<div className={css.fieldLabel}>Feedback Received</div>
					<div className={css.fieldValue}>{feedbackReceivedCount}</div>
				</div>

				<div className={css.fieldWrapper}>
					<div className={css.fieldLabel}>Completed Todos</div>
					<div className={css.fieldValue}>{completedTodoCount}</div>
				</div>
			</div>
		);
	};
}
